module.exports = __webpack_public_path__ + "static/media/T-shirt_rose.c597f956.svg";